var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FAFCFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E3E5E9",
    strokeDasharray: "8 8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 7.71875V8.26562L10.2227 7.85547C10.9648 7.67969 11.7461 7.75781 12.4297 8.10938C13.3281 8.55859 14.4023 8.55859 15.3008 8.10938L15.4961 8.01172C15.8867 7.79688 16.375 8.08984 16.375 8.53906V14.0078C16.375 14.2812 16.1992 14.4961 15.9648 14.5938L15.2812 14.8477C14.3828 15.1992 13.3867 15.1406 12.5078 14.7109C11.7656 14.3398 10.9258 14.2422 10.125 14.4375L8.5625 14.8281V16.7812C8.5625 17.0547 8.34766 17.25 8.09375 17.25C7.82031 17.25 7.625 17.0547 7.625 16.7812V15.0625V14.1055V8.5V7.71875C7.625 7.46484 7.82031 7.25 8.09375 7.25C8.34766 7.25 8.5625 7.46484 8.5625 7.71875ZM8.5625 9.24219V13.8711L9.89062 13.5391C10.9062 13.2852 12 13.4023 12.9375 13.8711C13.5625 14.1836 14.2852 14.2227 14.9492 13.9688L15.4375 13.793V9.06641C14.3242 9.51562 13.0742 9.47656 12.0195 8.94922C11.5312 8.69531 10.9648 8.63672 10.4375 8.77344L8.5625 9.24219Z",
    fill: "#4B5080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.e98d10e0f1bb23b885a141a950e1089f.svg";
export { ForwardRef as ReactComponent };